import axios from "axios";

const baseUrl = () =>
  `${process.env.VUE_APP_APIURL}/${process.env.VUE_APP_APIVER}`;

const defaultHeaders = () => ({
  "Request-Token": process.env.VUE_APP_SEC_HEADER,
  "Content-Type": "application/json",
});

export function url(path) {
  return `${baseUrl()}${path.startsWith("/") ? path : `/${path}`}`;
}

export function apiPost(path, data, options = {}) {
  return axios.post(url(path), data, {
    headers: { ...defaultHeaders(), ...(options.headers || {}) },
    ...options,
  });
}

export function apiPatch(path, data, options = {}) {
  return axios.patch(url(path), data, {
    headers: { ...defaultHeaders(), ...(options.headers || {}) },
    ...options,
  });
}

export function apiDelete(path, options = {}) {
  return axios.delete(url(path), {
    headers: { ...defaultHeaders(), ...(options.headers || {}) },
    ...options,
  });
}

export function apiGet(path, options = {}) {
  return axios.get(url(path), {
    headers: { ...defaultHeaders(), ...(options.headers || {}) },
    ...options,
  });
}
